import Container from "react-bootstrap/Container";
import "./Footer.css";
const Footer = () => {
    return (
        <>
            <footer className="footer mt-2 py-3 bg-light">
                <Container className="text-white text-center">
                    Copyright &#169; 2023
                </Container>
            </footer>
        </>
    );
};

export default Footer;
